<template>
  <div id="Step3">
    <div class="small-12 columns payment-summary">
      <p class="title">Payment summary</p>
      <div class="summary-pack" v-if="packages.length > 1">
        <div
          class="pack"
          v-if="
            this.packages.find((x) => x.code == donation.packagecode) != null &&
            packages.find((x) => x.code == donation.packagecode).pack != null
          "
          :style="
            'background-image:url(' +
            packages.find((x) => x.code == donation.packagecode).pack.image +
            ')'
          "
        ></div>
      </div>
      <div
        class="summary-pack"
        :class="
          packages.find((x) => x.code == donation.packagecode) != null &&
          packages.find((x) => x.code == donation.packagecode).toy != null
            ? 'has-toy'
            : ''
        "
        v-if="packages.length > 1"
      >
        <div
          class="toy"
          :style="
            packages.find((x) => x.code == donation.packagecode) != null &&
            packages.find((x) => x.code == donation.packagecode).toy != null
              ? 'background-image:url(' +
                packages.find((x) => x.code == donation.packagecode).toy.image +
                ')'
              : ''
          "
        ></div>
      </div>
      <div class="items">
        <p class="product">{{ donation.productname }}</p>
        <p class="amount">${{ donation.amount }}</p>
        <p class="frequency">
          <template v-if="donation.type === 'Regular'">Monthly</template>
          <template v-else-if="donation.type === 'Single'">One-off</template>
          <template v-else-if="donation.type === 'Annual'">Annually</template>
        </p>
      </div>
    </div>

    <h2>Enter payment details</h2>

    <div v-if="useNewCheckout">
      <div class="secure">
        <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/secure-icon.svg" />
        <div class="text">
          <p>Secure</p>
          <p>payment</p>
        </div>
      </div>

      <component
        :is="paymentform"
        @success="processSuccess"
        @retry="retryPayment"
        ref="checkout"
      ></component>
    </div>

    <div v-if="!useNewCheckout">
      <div class="iframe-loader">
        <iframe
          ref="frame"
          frameborder="0"
          @load="load"
          v-if="donation.url"
          scrolling="no"
          :src="donation.url"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import VueBamboraCustomCheckout from "./VueBamboraCustomCheckout";
import VueBamboraDirectDebit from "./VueBamboraDirectDebit";

import { mapState } from "vuex";

// Helpers
import { getNameByDonationType, getNameByPaymentType } from "./../../helpers";
import gtm from "./../../utils/gtm";

export default {
  components: {
    VueBamboraCustomCheckout, // Donation details (packages, handle, donation type, email, payement type)
    VueBamboraDirectDebit,
  },
  data() {
    return {
      isiframeLoading: false, // OLD BAMBORA CHECKOUT
    };
  },
  props: {
    thankYouUrl: {
      type: String,
      default: null,
    },
    useNewCheckout: {
      type: Boolean,
      default: false,
    },
    useProductThankYouUrl: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    paymentform() {
      if (
        this.$store.state.donation.donation.payementType ==
        "wwf_purchasetokenise"
      ) {
        return "vue-bambora-custom-checkout";
      } else {
        return "vue-bambora-direct-debit";
      }
    },
    ...mapState({
      donation: (state) => state.donation.donation,
      packages: (state) => state.product.packagesProduct,
      product: (state) => state.product.product,
    }),
  },
  methods: {
    processSuccess: function (data) {
      // Make the payment
      if (this.donation.payementType == "wwf_purchasetokenise") {
        // CREDIT CARD
        this.$store
          .dispatch("paymentCreditCard", {
            token: data.token,
            cardHolderName: data.cardHolderName,
          })
          .then((result) => {
            console.log("Payment success");
            this.$store.commit("setTransactionId", this.donation.key);
            this.$refs.checkout.reset();

            this.thanksUser();
          })
          .catch((error) => {
            console.error("Server Error", error);
            const isRestrictedIP = error.status == 403 && error.body;
            this.$refs.checkout.reset(
              isRestrictedIP ?
              error.body.message :
              "Oops something happened and we were not able to process your payment, please try again."
            );
          });
      } else {
        // DIRECT DEBIT
        this.$store
          .dispatch("paymentDirectDebit", {
            accno: data.accno,
            accrouting: data.accrouting,
            acctitle: data.acctitle,
          })
          .then((result) => {
            console.log("Payment success");
            this.$store.commit("setTransactionId", this.donation.key);
            this.thanksUser();

            this.$refs.checkout.reset();
          })
          .catch((error) => {
            console.error("Server Error", error);
            this.$refs.checkout.reset(
              "Oops something happened and we were not able to process your payment, please try again."
            );
          });
      }
    },
    thanksUser() {
      console.log("this.donation.thankYouUrl", this.donation.thankYouUrl);
      const donateThankYouUrl = this.donation.thankYouUrl;
      if (
        (this.useProductThankYouUrl && donateThankYouUrl) ||
        this.thankYouUrl
      ) {
        let query = `firstname=${this.donation.firstname}`;
        query += `&lastname=${this.donation.lastname}`;
        query += `&frequency=${this.donation.type}`;
        query += `&amount=${this.donation.amount}`;
        query += `&source=${document.URL}`;

        let params = "?q=" + window.btoa(query);
        const baseUrl =
          this.useProductThankYouUrl && donateThankYouUrl
            ? donateThankYouUrl
            : this.thankYouUrl;
        const url = baseUrl + params;

        // Send data to Google Tag Manager
        gtm.pushPurchase(
          this.donation.transactionid,
          this.product.productname,
          this.product.id,
          this.product.producttype,
          getNameByDonationType(this.donation.type),
          this.donation.amount,
          this.donation.billing.postcode,
          getNameByPaymentType(this.donation.payementType),
          function () {
            setTimeout(() => {
              window.open(url, "_self");
            }, 1000);
          }
        );
      } else {
        this.$store.commit("openDonationPopup", true);
      }
    },
    retryPayment: function () {
      this.$store
        .dispatch("retryDonation")
        .then((response) => {
          this.$refs.checkout.reset();
        })
        .catch((error) => {
          console.error("Retry donation error", error);
        });
    },
    load: function () {
      // OLD BAMBORA CHECKOUT
      this.isiframeLoading = true;
      console.log("src", this.donation.url);
      console.log("is loaded", this.isiframeLoading);
    },
  },
};
</script>

<style>
#Step3 .secure {
  margin: 10px 0;
}

/* WWF LOADER */

.wwf-loading-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.94);
  z-index: 99999;
  overflow: hidden;
  border-radius: 3px;
}

.wwf-form .wwf-loading-container:before {
  content: "Just a sec...";
  position: absolute;
  top: 50%;
  text-align: center;
  left: 0;
  right: 0;
  margin: 70px auto 0;
  font-weight: 600;
}

.wwf-form.loading {
  min-height: 450px;
}

.wwf-form.loading > *:not(.wwf-loading),
.wwf-form.loading *:not(span) {
  visibility: hidden;
  opacity: 0;
}

.wwf-form.loading .wwf-loading {
  visibility: visible;
  opacity: 1;
  display: block;
}

.wwf-loading {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  left: 0;
  right: 0;
  margin: -25px auto 0;
  top: 50%;
  z-index: 9;
  font-size: 0;
}

.wwf-loading span,
.wwf-loading:before,
.wwf-loading:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: block;
  font-size: 0;
}

.wwf-loading span {
  z-index: 3;
  background-image: url(https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/wwf-logo-solo.svg);
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: 50%;
  animation: wwfLogoLoading 1s linear infinite;
}

.wwf-loading:before {
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.03);
  animation: wwfLoading 1s linear infinite;
}

.wwf-loading:after {
  z-index: 1;
}

.iframe-loader .wwf-loading {
  display: block !important;
}

@keyframes wwfLogoLoading {
  0% {
    transform: scale(0.9);
  }

  10% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.9);
  }
}

@keyframes wwfLoading {
  0% {
    transform: scale(1);
    opacity: 0;
  }

  10% {
    transform: scale(1);
    opacity: 1;
  }

  70% {
    transform: scale(1.25);
    opacity: 1;
  }

  100% {
    transform: scale(1.25);
    opacity: 0;
  }
}

/* PROCESSING OVERLAY */

.wwf-loading-container.processing {
  position: fixed;
  border-radius: 0;
}

.processing-title {
  position: absolute;
  left: 0;
  right: 0;
  margin: 70px auto 0;
  top: 50%;
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
}
</style>

<style scoped>
/* PAYMENT SUMMARY */

.payment-summary {
  position: relative;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--wwfGreyE4);
  margin-bottom: 10px;
  padding-left: 0;
  padding-right: 0;
}

.payment-summary p.title {
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 600;
  color: rgba(34, 34, 34, 0.4);
  line-height: normal;
  margin-bottom: 15px;
}

.summary-pack {
  width: 60px;
  height: 60px;
  display: inline-block;
  background-color: var(--wwfGreyF3);
  border-radius: 50%;
  padding: 5px;
  vertical-align: top;
  position: relative;
}

.payment-summary .pack,
.payment-summary .toy {
  width: 50px;
  height: 50px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 50%;
  position: relative;
}

.summary-pack:before {
  content: "";
  position: absolute;
  z-index: 9;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  box-shadow: inset 0 0 20px 5px rgb(241, 241, 241);
  border-radius: 50%;
}

.summary-pack.has-toy:before {
  content: none;
}

.payment-summary .items {
  display: inline-block;
  padding: 8px 0 0;
}

.payment-summary .items p.product {
  font-size: 13px;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 0;
}

.payment-summary .items p.amount {
  color: var(--primaryColor);
  font-weight: 800;
  display: inline-block;
  font-size: 18px;
}

.payment-summary .items p.frequency {
  display: inline-block;
  font-size: 18px;
  font-weight: 400;
  color: var(--wwfGreyA7);
}

.payment-summary .toy:before {
  content: "+";
  position: absolute;
  left: -16px;
  color: var(--primaryColor);
  font-size: 32px;
  font-weight: 900;
  z-index: 10;
}

.payment-summary > div:nth-of-type(2) {
  display: none;
}

.payment-summary > div.has-toy {
  display: inline-block;
}

/* SECURE ICON */

.secure img {
  width: 60px;
  opacity: 0.8;
  margin-bottom: 15px;
  vertical-align: top;
}

.secure .text {
  display: inline-block;
}

.secure .text p {
  text-transform: uppercase;
  font-weight: 800;
  line-height: normal;
  margin: 0;
  font-size: 12px;
}

.secure .text p:last-child {
  font-weight: 400;
}

/* OLD BAMBORA CHECKOUT */
.wwf-form #Step3 iframe {
  height: 550px;
  width: 1px;
  min-width: 100%;
  position: relative;
  z-index: 9999;
  background-color: white;
}

.iframe-loader {
  width: 100%;
  height: 550px;
  position: relative;
  overflow: hidden;
}

.iframe-loader .wwf-loading {
  display: block !important;
}
</style>


// WEBPACK FOOTER //
// Step3.vue?bce9d692